import { useState } from 'react';
import { CATEGORIES } from '../utils/helpers';

export function EditItemModal({ item, onClose, onSave }) {
  const [name, setName] = useState(item.name);
  const [category, setCategory] = useState(item.category || 'sonstiges');
  const [expiryDate, setExpiryDate] = useState(item.expiry_date || '');
  const [quantity, setQuantity] = useState(item.quantity || 1);
  const [unit, setUnit] = useState(item.unit || 'Stk');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave({
        name,
        category,
        expiry_date: expiryDate || null,
        quantity: parseFloat(quantity) || 1,
        unit,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-title">Produkt bearbeiten</div>

        <div className="form-group">
          <label>Name</label>
          <input
            className="input"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Kategorie</label>
          <select
            className="input"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            {Object.entries(CATEGORIES).map(([key, { icon, label }]) => (
              <option key={key} value={key}>{icon} {label}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Haltbar bis</label>
          <input
            className="input"
            type="date"
            value={expiryDate}
            onChange={(e) => setExpiryDate(e.target.value)}
          />
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          <div className="form-group" style={{ flex: 1 }}>
            <label>Menge</label>
            <input
              className="input"
              type="number"
              min="0.1"
              step="0.1"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label>Einheit</label>
            <select
              className="input"
              value={unit}
              onChange={(e) => setUnit(e.target.value)}
            >
              <option value="Stk">Stück</option>
              <option value="kg">kg</option>
              <option value="g">g</option>
              <option value="L">Liter</option>
              <option value="ml">ml</option>
              <option value="Pkg">Packung</option>
            </select>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
          <button className="btn btn-outline" style={{ flex: 1 }} onClick={onClose}>
            Abbrechen
          </button>
          <button
            className="btn btn-primary"
            style={{ flex: 1 }}
            onClick={handleSave}
            disabled={!name.trim() || saving}
          >
            {saving ? 'Speichern...' : 'Speichern'}
          </button>
        </div>
      </div>
    </div>
  );
}
